import PageTitleComponent from './page-title-component'

/***
 * A title at the top of one of the non-home pages.
 */
const pageTitle = angular
    .module('FacilityData.Common.PageTitle', [])
    .component('pageTitle', PageTitleComponent)
    .name;

export default pageTitle;


// WEBPACK FOOTER //
// ./app/common/page-title/page-title.js